// store/middleware/forceStoresCacheMiddleware.ts
import { Middleware } from "@reduxjs/toolkit";
import { saveToStorage } from "../../common/utils/functions/localStorage";

const FORCE_STORES_ACTIONS = [
  "store-list/setForceStores",
  "store-list/addForceStore",
  "store-list/removeForceStore",
];

export const forceStoresCacheMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type && FORCE_STORES_ACTIONS.includes(action.type)) {
      const state = store.getState();
      const forceStores = state.storeList.forceStores;

      try {
        saveToStorage("forceStores", forceStores);
      } catch (error) {
        console.error("Ошибка сохранения выбранных точек:", error);
      }
    }

    return result;
  };
